import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoginAct, Logout, Loadme, settingUser } from "../reduxaction/user";
import { LogInInpayload, settingUsertype } from "./userpayloadtypes";

interface InitialState {
  // me: LogInInpayload[] | null;
  me: LogInInpayload | null;

  userInfo: any;

  LoginLoading: boolean; // 로그인 시도중
  LoginDone: boolean;
  LoginError: string | null;

  LoadmeLoading: boolean; // 로그인 시도중
  LoadmeDone: boolean;
  LoadmeError: string | null;

  LogoutLoading: boolean; //
  LogoutDone: boolean;
  LogoutError: string | null;

  Routerpath: string;

  settingUserInfo: settingUsertype | null;
  settingUserLoading: boolean; // 로그인 시도중
  settingUserDone: boolean;
  settingUserError: string | null;
}

const initialState: InitialState = {
  me: null,
  userInfo: null,

  LoginLoading: false, // 로그인 시도중
  LoginDone: false,
  LoginError: null,

  LoadmeLoading: false, //
  LoadmeDone: false,
  LoadmeError: null,

  LogoutLoading: false, //
  LogoutDone: false,
  LogoutError: null,

  Routerpath: "/MainPage",

  settingUserInfo: null,
  settingUserLoading: false, // 로그인 시도중
  settingUserDone: false,
  settingUserError: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addPostToMe(state: any, action) {
      state.me.Posts.unshift({ id: action.payload });
    },
    reMoveme(state) {
      state.me = null;
    },

    Routerpath(state, action: PayloadAction<string>) {
      state.Routerpath = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      //login
      .addCase(LoginAct.pending, (state) => {
        console.log("펜딩");
        state.LoginLoading = true;
        state.LoginDone = false;
        state.LoginError = null;
      })
      .addCase(
        LoginAct.fulfilled,
        (state, action: PayloadAction<LogInInpayload>) => {
          console.log("성공", console.log(action.payload));

          state.LoginLoading = false;
          state.me = action.payload;
          state.LoginDone = true;
        }
      )
      .addCase(LoginAct.rejected, (state, action: any) => {
        console.log("실패");
        state.LoginLoading = false;
        state.LoginError = action.payload;
      })

      //logout
      .addCase(Logout.pending, (state) => {
        state.LogoutLoading = true;
        state.LogoutDone = false;
        state.LogoutError = null;
      })
      .addCase(Logout.fulfilled, (state, action) => {
        state.LogoutLoading = false;
        state.me = null;
        state.LogoutDone = true;
      })
      .addCase(Logout.rejected, (state, action: any) => {
        state.LogoutLoading = false;
        state.LogoutError = action.payload;
      })

      // // loadMe
      .addCase(Loadme.pending, (state) => {
        state.LoadmeLoading = true;
        state.LoadmeDone = false;
        state.LoadmeError = null;
      })
      .addCase(Loadme.fulfilled, (state: any, action) => {
        state.LoadMeLoading = false;
        state.LoadMeDone = true;
        state.me = action.payload;
      })
      .addCase(Loadme.rejected, (state, action: any) => {
        state.LoadmeLoading = false;
        state.LoadmeError = action.payload;
      })

      // settingUser

      .addCase(settingUser.pending, (state) => {
        state.settingUserLoading = true;
        state.settingUserDone = false;
        state.settingUserError = null;
      })
      .addCase(
        settingUser.fulfilled,
        (state: any, action: PayloadAction<settingUsertype>) => {
          state.settingUserLoading = false;
          state.settingUserDone = true;
          state.settingUserInfo = action.payload;
        }
      )
      .addCase(settingUser.rejected, (state, action: any) => {
        state.settingUserLoading = false;
        state.settingUserError = action.payload;
      })

      .addDefaultCase((state) => state),
});

export default userSlice;
